if (!customElements.get('joker-sticky-cart')) {
  customElements.define('joker-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.scrollFrame = 0;
      this.host = this.closest('product-info');
      if (this.closest('quick-add-modal') || this.host?.dataset.originalSection) return;
      this.original = this.host?.querySelector(`#ProductSubmitButton-${CSS.escape(this.dataset.sectionId)}`);
      this.price = this.host?.querySelector(`#price-${CSS.escape(this.dataset.sectionId)}`);
      this.action = this.querySelector('[data-sticky-submit]');
      this.amount = this.querySelector('[data-sticky-price]');
      if (!this.original || !this.price || !this.original.form) return;
      this.initialized = true;
      this.media = window.matchMedia('(max-width: 749px)');
      this.onVisibilityChange = () => this.updateVisibility();
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.updateVisibility();
        });
      };
      this.onSubmit = () => {
        if (this.original.disabled || this.original.getAttribute('aria-disabled') === 'true') return;
        this.original.form.requestSubmit(this.original);
      };
      this.action.addEventListener('click', this.onSubmit);
      this.media.addEventListener('change', this.onVisibilityChange);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.intersection = new IntersectionObserver(this.onVisibilityChange);
      this.intersection.observe(this.original);
      this.mutation = new MutationObserver(() => this.sync());
      this.mutation.observe(this.original, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
      this.mutation.observe(this.price, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
      this.sync();
      this.updateVisibility();
    }
    sync() {
      const unavailable = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
      this.action.disabled = unavailable;
      const label = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
      if (this.action.textContent !== label) this.action.textContent = label;
      const priceNode = this.price.querySelector('.price--on-sale .price-item--sale') || this.price.querySelector('.price-item--regular');
      const priceText = this.price.classList.contains('hidden') ? '' : priceNode?.textContent.trim() || '';
      if (this.amount.textContent !== priceText) this.amount.textContent = priceText;
    }
    updateVisibility() {
      const show = this.media.matches && this.original.getBoundingClientRect().bottom < 0;
      this.hidden = !show;
      document.body.classList.toggle('joker-sticky-cart-visible', show);
      if (show) document.body.style.setProperty('--joker-sticky-height', `${this.getBoundingClientRect().height}px`);
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.intersection?.disconnect();
      this.mutation?.disconnect();
      this.media?.removeEventListener('change', this.onVisibilityChange);
      window.removeEventListener('scroll', this.onScroll);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = 0;
      this.action?.removeEventListener('click', this.onSubmit);
      document.body.classList.remove('joker-sticky-cart-visible');
      document.body.style.removeProperty('--joker-sticky-height');
      this.initialized = false;
    }
  });
}
